
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"42","height":"42"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Subtraction 25","d":"M21 42a21.005 21.005 0 01-8.174-40.35 21.005 21.005 0 0116.348 38.7A20.869 20.869 0 0121 42zm-9.449-25.985c-.57 0-1.133.005-1.674.016a.744.744 0 00-.653.248.749.749 0 00.054.7 40.879 40.879 0 004.335 7.721 10.71 10.71 0 003.293 3.083 8.442 8.442 0 004.307 1.066c.186 0 .383 0 .587-.014.819-.038 1.054-.264 1.089-1.054a3.536 3.536 0 01.36-1.6.737.737 0 01.634-.451.943.943 0 01.505.174 3.29 3.29 0 01.612.556c.149.163.3.33.444.492.3.334.606.678.924 1a2.659 2.659 0 001.951.895c.074 0 .15 0 .226-.009h3.42a.666.666 0 00.539-.35 1.043 1.043 0 00-.018-.976 6.8 6.8 0 00-.824-1.187 20.506 20.506 0 00-1.675-1.716c-.205-.194-.418-.4-.624-.6-.7-.686-.742-1.088-.182-1.871.326-.457.671-.913 1.005-1.353.3-.392.6-.795.894-1.2l.068-.094a8.959 8.959 0 001.411-2.471.825.825 0 00.006-.682.828.828 0 00-.611-.307 2 2 0 00-.329-.02h-3.749a.826.826 0 00-.845.6c-.2.5-.432 1.074-.705 1.626a13.413 13.413 0 01-2.176 3.345l-.037.04a.866.866 0 01-.576.361.5.5 0 01-.155-.026c-.43-.158-.552-.87-.545-1.1v-4.294c-.083-.611-.216-.885-.827-1.006h-3.87a1.233 1.233 0 00-1.049.522c-.087.1-.14.184-.118.248s.1.094.238.121a1.3 1.3 0 011.1 1.179 12.97 12.97 0 01.055 3.092 2.885 2.885 0 01-.2.882c-.116.275-.277.414-.478.414a.746.746 0 01-.408-.153 3.624 3.624 0 01-.857-.943 20.6 20.6 0 01-2.269-4.206.98.98 0 00-.928-.695c-.573.002-1.136-.003-1.675-.003z","fill":"#fff"}})])
          )
        }
      }
    